import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { DocumentSerieNewCrumbs } from 'civil-status/constants/document-serie-breadcrumb';
import FormDocumentSerie, { DocumentSerieForm } from 'civil-status/components/document-serie/form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';

const DocumentSerieNewPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const insertSerie = useHttpClient(`${__CIVIL_STATUS_API_URL__}/serie-atto/crea-serie-atto`, {
    options: {
      method: 'POST',
    },
  });

  const handleSubmit = useCallback(
    (values: DocumentSerieForm) => {
      (
        insertSerie({
          data: {
            serie: values.description,
            key: {
              codiceSerie: values.number,
            },
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/serie');
      });
    },
    [insertSerie, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={DocumentSerieNewCrumbs} />
      <FormDocumentSerie
        title={'Nuova Serie'}
        onOk={handleSubmit}
        onCancel={() => {
          navigate('/stato-civile/serie');
        }}
      ></FormDocumentSerie>
    </Fragment>
  );
};

DocumentSerieNewPage.displayName = 'Document Serie New page component';

export default DocumentSerieNewPage;
